module.exports = __webpack_public_path__ + "static/media/bg-discover-rewards.7ab4be1f.png";